import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from 'pages/Home';
import Tools from 'pages/Tools';
import Assets from 'pages/Assets';
import People from 'pages/People';
import Users from 'pages/Users';
import Famas from 'pages/Famas';
import Qr from 'pages/Qr';
import ForApproval from 'pages/ForApproval';
import NotFound from 'pages/NotFound';
import Depts from 'pages/toolsdeptlink';
import BU from 'pages/toolsbulink';
import Wf from 'pages/workflow';
import OverallReport from 'pages/OverallReport';
import QueryReport from 'pages/QueryReport';
import Approval from 'pages/Approval';

const SwitchRoutes = () => {
	return (
		<Switch>
			
			<Route exact path="/" component={Home} />
			<Route exact path="/home" component={Home} />
			<Route exact path="/eams" component={Home} />
			<Route path="/tools" component={Tools}/>
			<Route path="/assets" component={Assets}/>
			<Route path="/people" component={People}/>
			<Route path="/users" component={Users}/>
			<Route path="/famas" component={Famas}/>
			<Route path="/dept" component={Depts}/>
			<Route path="/bu" component={BU}/>
			<Route path="/qr" component={Qr}/>
			<Route path="/workflow" component={Wf}/>
			<Route path="/reports/overall" component={OverallReport} />
			<Route path="/reports/query" component={QueryReport} />
			<Route path="/reports/approval" component={Approval} />
			<Route exact path="/forapproval" component={ForApproval}/>
			<Route component={NotFound} />
		</Switch>
	);
};

export default SwitchRoutes;
